import { OverlappingMarkerSpiderfier } from "ts-overlapping-marker-spiderfier/dist/oms";

document.addEventListener("DOMContentLoaded", function () {
  const plantMap = document.getElementById("map-plant");
  const plantsMap = document.getElementById("map-plants");

  if (plantMap) {
    initDetailMap(plantMap);
  }

  if (plantsMap) {
    initOverviewMap(plantsMap);
  }
});

function initDetailMap(mapElement) {  
  const plant = JSON.parse(mapElement.getAttribute('data-plant'));
  const map = createMap(mapElement, new google.maps.LatLng(plant.latitude, plant.longitude), 14);
  const infoWindow = new google.maps.InfoWindow();
  createMarker(map, plant, infoWindow);
}

function initOverviewMap(mapElement) {
  const plants = JSON.parse(mapElement.getAttribute('data-plants'));
  const moreInfoLabel = mapElement.getAttribute('data-more-info-label');
  const map = createMap(mapElement, new google.maps.LatLng(51, 4), 4);
  const infoWindow = new google.maps.InfoWindow();
  const bounds = new google.maps.LatLngBounds();

  const spiderfier = new OverlappingMarkerSpiderfier(map, {
    markersWontMove: true,
    markersWontHide: true,
    basicFormatEvents: true,
    nearbyDistance: 50
  });

  plants.forEach(plant => {
    let marker = createMarker(map, plant, infoWindow, moreInfoLabel);

    spiderfier.addMarker(marker);
    bounds.extend(marker.getPosition());
  });

  map.fitBounds(bounds);
}

function createMap(mapElement, startPoint, zoomLevel) {
  return new google.maps.Map(mapElement, {
    center: startPoint,
    zoom: zoomLevel,
    styles: mapStyle,
    mapTypeControl: false,
    streetViewControl: false
  });
}

function createMarker(map, plant, infoWindow, moreInfoLabel) {
  const marker = new google.maps.Marker({
    map: map,
    position: { lat: plant.latitude, lng: plant.longitude },
    title: plant.name,
    icon: {
      url: plant.iconSrc,
      scaledSize: new google.maps.Size(20, 30)
    }
  });

  const link = plant.url && moreInfoLabel ? `<a href="${plant.url}">${moreInfoLabel} &gt;</a>` : "";
  const info = `
    <div>
      <h6 class="u-color-beta-base u-mb-beta">${plant.name}</h6>
      <p class="u-mb-beta">
        ${plant.addressLine1}
        <br />${plant.addressLine2}
        <br />${plant.country}
      </p>
      ${link}
    </div>`;

  marker.addListener("click", () => {
    infoWindow.setContent(info);
    infoWindow.open(map, marker);
  });

  return marker;
}

const mapStyle = [
  {
    "featureType": "water",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#c9c9c9"
      },
      {
        "lightness": 25
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      },
      {
        "lightness": 20
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#ffffff"
      },
      {
        "lightness": 17
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#ffffff"
      },
      {
        "lightness": 29
      },
      {
        "weight": 0.2
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      },
      {
        "lightness": 18
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      },
      {
        "lightness": 16
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      },
      {
        "lightness": 21
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dedede"
      },
      {
        "lightness": 21
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "visibility": "on"
      },
      {
        "color": "#ffffff"
      },
      {
        "lightness": 16
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "saturation": 36
      },
      {
        "color": "#333333"
      },
      {
        "lightness": 40
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f2f2f2"
      },
      {
        "lightness": 19
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#fefefe"
      },
      {
        "lightness": 20
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#fefefe"
      },
      {
        "lightness": 17
      },
      {
        "weight": 1.2
      }
    ]
  },
  {
    "featureType": "administrative.country",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "visibility": "on"
      },
      {
        "color": "#333333"
      },
      {
        "lightness": 60
      },
      {
        "weight": 1
      }
    ]
  }
];